export const MIN_LAST_AGENT_DURATION_MINUTES = 1;
export const MAX_LAST_AGENT_DURATION_MINUTES = 1440;
export const DEFAULT_LAST_AGENT_DURATION_MINUTES = 60;
